<template>
  <base-layout
    toolbarActive
    :toolbarClass="String(mobile ? 'content-bg--3' : false)"
  >
    <template #toolbarBase>
      <hint-widget hintName="hotspotAddNew" type="tooltip">
        <template slot="activatorHint">
          <div
            @click="$emit('openDialog', { component: 'hotspotOrder' })"
            class="font-weight-medium title"
            :class="{ headline: mobile, link: !mobile }"
          >
            <icon-plus
              :color="mobile ? $vuetify.theme.primary : $vuetify.theme.link"
            ></icon-plus>
            Добавить новый хот-спот
          </div>
        </template>
      </hint-widget>
    </template>

    <v-layout
      v-if="mobile"
      class="tabs text-uppercase content-bg--3 font-weight-medium"
    >
      <v-flex
        @click="tabActive = 0"
        :class="{ 'primary--text tabs-active': tabActive === 0 }"
        class="text-xs-center link pb-2"
      >
        Хот-споты
      </v-flex>
      <v-flex
        v-if="checkNews"
        @click="tabActive = 1"
        :class="{ 'primary--text tabs-active': tabActive === 1 }"
        class="text-xs-center link pb-2"
      >
        Новости
      </v-flex>
      <v-flex
        @click="tabActive = 2"
        :class="{ 'primary--text tabs-active': tabActive === 2 }"
        class="text-xs-center link pb-2"
      >
        Шаблоны
      </v-flex>
    </v-layout>

    <v-container
      class="fluid pt-0"
      :class="{
        'px-4': !mobile,
        'px-0': mobile,
        'align-center fill-height': !hotspotList.length
      }"
    >
      <v-layout v-if="!hotspotList.length" class="justify-center align-center">
        <v-progress-circular
          v-if="!loaded"
          :size="70"
          :width="4"
          color="primary"
          indeterminate
        ></v-progress-circular>
        <div v-else>
          Не найдены активные услуги. Обратитесь в Тех. поддержку.
        </div>
      </v-layout>
      <v-layout v-else wrap>
        <v-expansion-panel
          v-if="!mobile || (mobile && tabActive === 0)"
          :value="panel"
          :readonly="!mobile"
          class="flex xl9 lg8 md8"
          :class="{ 'pr-4': !mobile }"
          :expand="!mobile"
        >
          <hotspot-item
            @openDialog="openDialog"
            v-for="hotspot in hotspotList"
            :key="hotspot.id"
            :id="hotspot.id"
          ></hotspot-item>
        </v-expansion-panel>
        <v-flex xl3 lg4 md4>
          <Templates
            v-if="!mobile || (mobile && tabActive === 2)"
            :class="{ 'content-bg--4': !mobile }"
          />
          <News
            v-if="!mobile || (mobile && tabActive === 1)"
            class="border-light pb-3"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </base-layout>
</template>

<script>
import HotspotItem from "../components/hotspot/HotspotItem.vue";
import BaseLayout from "../components/layout/BaseLayout.vue";
import IconPlus from "../components/icon/IconPlus.vue";
import Templates from "../components/template/Templates.vue";
import News from "../components/news/News.vue";
import HintWidget from "../components/common/HintWidget.vue";

export default {
  name: "HotspotView",

  components: {
    IconPlus,
    BaseLayout,
    HotspotItem,
    News,
    Templates,
    HintWidget
  },

  data: () => ({
    // анимация загрузки данных
    loaded: false,
    // активные элементы для tabs
    tabActive: 0
  }),

  async mounted() {
    // загружаем список хотспотов
    await this.$store.dispatch("hotspotListLoad");
    this.loaded = true;
    // загружаем список тем
    this.$store.dispatch("themeListLoad");
    // загружаем список рекламы
    this.$store.dispatch("advListLoad");
    // загружаем список опросов
    this.$store.dispatch("pollListLoad");
  },

  computed: {
    // список хотспотов клиента
    hotspotList() {
      let list = [];
      if (this.$store.getters.hotspotIsLoaded) {
        list = this.$store.getters.hotspotList;
      }
      return list;
    },
    // для expandPanel, список открытых плашек по ключу
    panel() {
      let list = [];
      if (this.mobile && this.hotspotList.length === 1) {
        return 0;
      } else if (!this.mobile && this.hotspotList) {
        list = this.hotspotList.map(() => true);
      }
      return list;
    },
    // для expandPanel, все плашки только для чтения (не сворачиваются)
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    // проверка на наличие новостей
    checkNews() {
      if (this.$store.getters.newsList.length) return true;

      return false;
    }
  },

  methods: {
    openDialog(params) {
      this.$emit("openDialog", params);
    }
  }
};
</script>
